<template>
  <div class="step-wrap" :class="{ iframeFontLarge: isInPassport }">
    <p class="mb-20">{{ languages.delEmailMsg1 }}</p>
    <p class="mb-20">
      {{ languages.delEmailMsg2 }}
    </p>
    <p class="mb-20">{{ languages.delEmailMsg3 }}</p>
    <div>
      <van-radio-group v-model="choose">
        <van-radio :name="1">{{ languages.delEmailConfirmYes }}</van-radio>
        <div class="mt-20">
          <TempInput
            :formData="formData"
            id="email"
            :required="false"
            label=""
            :placeholder="languages.delEmailFill"
          ></TempInput>
        </div>
        <van-radio :name="0">{{ languages.delEmailConfirmNo }}</van-radio>
      </van-radio-group>
    </div>
    <div class="btn-wrap flex mb-60">
      <van-button class="btn" block type="info" @click="prevStep">
        {{ languages.delPrevStep }}
      </van-button>
      <van-button class="btn" block type="info" @click="handleNextStep">
        {{ languages.delNextStep }}
      </van-button>
    </div>
  </div>
</template>

<script>
import TempInput from '@components/officialSupport/workTemp/TempInput.vue';
import accountDelete from '@mixins/officialSupport/accountDelete';
import { stepKey } from '@configs/officialSupport/accountDelete';
import { validSupportEmail } from '@utiles/officialSupport';
export default {
  name: 'EmailNotice',
  mixins: [accountDelete],
  data() {
    return {
      choose: 1,
      formData: {
        email: null
      },
      compKey: stepKey.emailNotice
    };
  },
  methods: {
    handleNextStep() {
      if (this.choose) {
        if (!this.formData.email) {
          this.$toast(this.languages.delEmailFill);
          return;
        }
        if (!validSupportEmail(String(this.formData.email).trim())) {
          this.$toast(this.languages.inputValidEmail);
          return;
        }
        this.updateSubmitForm({
          email: this.formData.email
        });
        this.nextStep();
        return;
      }
      this.updateSubmitForm({
        email: ''
      });
      this.nextStep();
    }
  },
  components: {
    TempInput
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialSupport/workTempForm.scss';
@import '@assets/scss/officialSupport/accountDelete.scss';
</style>
